<template>
  <div class="blog-list-wrapper" :class="{ collapsed: this.$root.isCollapsed && !isMobile, notification: this.$root.warning && this.$root.warning !== 'NORMAL' && !isMobile, }">
    <div class="wrapper">
      <div class="list">
        <div
          class="blog-card"
          v-for="blog in blogs"
          :key="blog.id"
          @click="redirectToBlog(blog)"
        >
          <div class="blog-info-wrapper">
            <img
              :src="
                this.$root.getCDNlink(blog.bannerImage) ||
                '../../assets/blogBanner1.webp'
              "
              class="blog-image"
            />
            <div class="blog-description-wrapper">
              <div class="blog-category">{{ blog.category }}</div>
              <div class="blog-title">{{ blog.title }}</div>
              <p class="blog-description">{{ blog.summary }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import config from "@/config.js";
import { GetBlog } from "@/api/APIs";

export default {
  name: "ExistingBlogsList",
  props: ["category"],
  components: {},
  data() {
    return {
      blogs: [],
      selectedCategory: "",
    };
  },
  mounted() {
    this.getBlogsList();
  },
  methods: {
    async getBlogsList() {
      const payload = {
        category: this.selectedCategory,
      };

      try {
        const response = await GetBlog(payload);
        if (response.message === "SUCCESS") {
          this.blogs = response.blog;
        } else {
          return this.$refs.toastContainer.addToast(response.message, {
            type: "error",
          });
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
    },
    redirectToBlog(blog) {
      this.$router.push(`/existing-blog-editor?blogId=${blog.id}`);
    },
  },
};
</script>

<style scoped>
.blog-list-wrapper {
  display: flex;
  flex-direction: column;
  gap: 25px;
  margin-left: 18vw;
  padding-top: 55px;
  transition: margin-left 0.3s ease;
}
.blog-list-wrapper.collapsed {
  margin-left: 60px;
}
.blog-list-wrapper.notification {
  padding-top: 105px !important;
}
.wrapper {
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: flex-start;
  justify-content: center;
}
.line-22 {
  border-width: 1px 0 0 0;
  border-style: solid;
  border-image: linear-gradient(
    270deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(191 191 191) 49.50000047683716%,
    rgba(134, 134, 134, 0) 100%
  );
  border-image-slice: 1;
  flex-shrink: 0;
  width: 95%;
  height: 0px;
  position: relative;
}
.categories-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  /* gap: 20px; */
  width: 30%;
  /* border: 1px solid rgb(216, 216, 216); */
  border-radius: 10px;
  padding: 20px;
  background-color: white;
  box-shadow: 4px 4px 8px 0px rgba(0, 0, 0, 0.18),
    -4px -4px 8px 0px rgba(255, 255, 255, 1);
  position: sticky;
  top: 110px;
}
.categories-title {
  text-align: left;
  font-size: 20px;
  font-weight: 600;
  font-family: "Figtree";
  color: #224096;
  line-height: 0;
  margin-top: 10px;
}
.categories-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  /* gap: 15px; */
  width: 100%;
}
.categories-list span {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  font-family: "Figtree";
  line-height: 50px;
  cursor: pointer;
  align-self: stretch;
  padding-left: 10px;
  border-radius: 8px;
}
.categories-list span:hover {
  background: #c5d3e02f;
}
.blogs-title {
  text-align: left;
  font-size: 30px;
  font-weight: 600;
  font-family: "Figtree";
  color: #224096;
}
.list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: 20px;
  padding: 2rem;
}
.blog-card {
  /* border: 1px solid rgb(228, 228, 228); */
  border-radius: 13px;
  padding: 20px;
  box-shadow: 4px 4px 8px 0px rgba(0, 0, 0, 0.18),
    -4px -4px 8px 0px rgba(255, 255, 255, 1);
  background-color: white;
  display: flex;
  align-self: stretch;
  cursor: pointer;
}
.blog-info-wrapper {
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
}
.blog-image-wrapper {
  width: 40%;
  height: 100%;
}
.blog-image {
  width: 20%;
  /* height: 100%; */
  aspect-ratio: 1/1;
  border-radius: 10px;
  object-fit: cover;
}
.blog-description-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 15px;
  width: 70%;
}
.blog-category {
  font-size: 16px;
  font-weight: 600;
  font-family: "Figtree";
  text-align: left;
  color: #046BE1;
}
.blog-title {
  font-size: 25px;
  font-weight: 600;
  font-family: "Figtree";
  text-align: left;
}
.blog-description {
  font-size: 16px;
  font-weight: 500;
  font-family: "Figtree";
  text-align: justify;
}

@media only screen and (max-width: 767px) {
  .blog-list-wrapper{
        padding: 4rem 1rem;
        margin: 0 auto !important;
  }
  .blogs-title {
    font-size: 16px;
  }

  .categories-wrapper {
    width: 100%;
    order: 2;
    padding: 0;
  }
  .list {
    width: 100%;
    order: 1;
            padding: 1rem;
  }
  .categories-title {
    margin: 2rem 0 0 2rem;
  }
  .categories-list {
    margin: 0 0 2rem 2rem;
    gap: 10px;
  }
  .line-22 {
    width: 80%;
  }
  .blog-category {
    font-size: 12px;
  }
  .blog-title {
    font-size: 14px;
  }
  .blog-description {
    font-size: 12px;
    margin: 0;
  }
  .blog-info-wrapper {
    flex-direction: column;
  }
  .blog-image {
    width: 100%;
    aspect-ratio: 16/ 9;
  }
  .blog-card {
    padding: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1022px) {
  .blog-list-wrapper{
        padding: 4rem 1rem;
        margin: 0 auto !important;
  }
  .blogs-title {
    font-size: 25px;
  }
  .blog-title {
    font-size: 20px;
  }
  .blog-description {
    font-size: 14px;
  }
  .list {
    gap: 20px;
  }
}
@media only screen and (min-width: 1156px) {
}
</style>
